import { Typography } from "@mui/material";
import React from "react";
import { themes, fonts } from "../themes/themes";

interface employeeFullName {
  first_name?: string;
  last_name?: string;
  isDashboard?: boolean;
}
const EmployeeFullName: React.FC<employeeFullName> = ({
  first_name,
  last_name,
  isDashboard = false,
}) => {
  return first_name || last_name ? (
    <Typography
      style={{
        color: isDashboard ? themes.primary : themes.darkBlue,
        fontSize: isDashboard ? fonts.xl_25 : fonts.title,
        fontFamily: fonts.fontFamily,
        fontWeight: "bolder",
      }}
    >
      {first_name} {last_name}
    </Typography>
  ) : (
    <Typography
      style={{
        color: themes.greySubtitle,
        fontSize: fonts.title,
        fontFamily: fonts.fontFamily,
        fontStyle: "italic",
      }}
    >
      No, such user!
    </Typography>
  );
};
export default EmployeeFullName;
